var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", staticStyle: { overflow: "auto" } },
    [
      _c(
        "Titlebar",
        { attrs: { incrustation: "fa-lock", backPath: "/home" } },
        [
          _vm.target
            ? _c("h1", {
                staticStyle: { "font-weight": "900" },
                domProps: { textContent: _vm._s(_vm.target.title) },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.target
            ? _c("ModuleDescription", {
                attrs: {
                  title: _vm.target.title,
                  description1: _vm.target.description1,
                  description2: _vm.target.description2,
                  description3: _vm.target.description3,
                  image4: _vm.target.image4,
                  option: _vm.target.option,
                  level: _vm.target.level,
                  "is-premium-module": _vm.target.isPremiumModule,
                  "is-user-premium": _vm.isPremiumUser,
                  "demo-link": _vm.target.demoLink,
                  "know-more-link": _vm.target.knowMoreLink,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }